
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': 'Historie',
	'noDashboardFound': 'Historien kan ikke hentes. Det finnes ikke lenger, eller du har ikke nok rettigheter til å vise det.',
	'noDashboardCapability': 'Du har ikke mulighet til å bruke historier',
	'noDashboardPermision': 'Du har ikke tilstrekkelige rettigheter for å vise denne historien',
	'defaultName': 'Ny historie',
	'storyProperties': 'Historieegenskaper',
	'createAvDataStoryLabel': 'Historie',
	'createAvSlideShowLabel': 'Lysbildefremvisning',
	'createAvPanAndZoomLabel': 'Guidet reise',
	'dashboard_save_success': 'Historien er lagret.',
	'cmEmptySelection': 'Historien er slettet. Prøv å lagre som en ny historie.',
	'createStoryTitle': 'Opprett en historie',
	'transitionStyleTitle': 'Overgangsstil',
	'createButton': 'Opprett',
	'cancelButton': 'Avbryt',
	'dashboardResetTitle': 'Tilbakestill historie',
	'dashboardResetMessage': 'Er du sikker på at du vil tilbakestille alle endringene som er tatt i bruk for denne historien?',
	'dashboardResetToast': 'Historien er tilbakestilt.',
	'filter_drag_and_drop_all_tabs': 'Dra og slipp data her for å filtrere alle scener.',
	'filter_drag_and_drop_current_tab': 'Dra og slipp data her for å filtrere denne scenen.',
	'filterIconLabel_Global': 'Alle scener',
	'filterIconLabel_Tab': 'Denne scenen',
	'filterIconTooltip_Global': 'Alle scener',
	'filterIconTooltip_Tab': 'Denne scenen',
	'filterOverflowMenu_Global': 'Overflytmeny for alle scener',
	'filterOverflowMenu_Tab': 'Overflytmeny for denne scenen',
	'renameScene': 'Endre navn på scene',
	'duplicateScene': 'Dupliser scene',
	'deleteScene': 'Slett scene',
	'editTimelineHighlight': 'Rediger utheving',
	'deleteTimelineHighlight': 'Slett utheving',
	'filter_includesAll': 'Inkluderer alle',
	'timeline_highlight_moved_to': 'Tidlinjeutheving %{id} flyttet til %{time}',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': 'Velg',
	'newDefaultStoryName': 'Historie: %{modelName}',
	'exportLabel': 'Lagre',
	'exportAsLabel': 'Lagre som:',
	'exportDialogTitle': 'Lagre som en historie',
	'exportDialogFooter': 'Lagre- og Avbryt-knapper',
	'loadAfterExportLabel': 'Åpne historie etter lagring',
	'selectTemplateLabel': 'Velg en mal',
	'outOfBoundsWarningMessage': 'Noen dashbordwidgeter ligger utenfor rutenettet og blir kanskje ikke vist på riktig måte etter eksport.',
	'emptyExploreCardsWarningMessage': 'Tomme kort ble slettet ved lagring som en historie.',
	'dashboard_export_success': 'Dashbordet er lagret som en historie.',
	'explore_export_success': 'Utforskingen er lagret som en historie.',
	'toastUpgradeDone': 'Historien er oppgradert. Lagre nå for å opprettholde optimal ytelse.',
	'navigationMarker': 'Navigeringsmerke',
	'navigateMarkers': 'Naviger i merker',
	'navNextMarker': 'Neste merke',
	'navPrevMarker': 'Forrige merke',
	'navPrevMarkerAbbreviated': 'Forr merke',
	'timelineSettingsButton': 'Alternativer for avspilling',
	'autoPlay': 'Spill av alle scener',
	'loop': 'Sløyfe',
	'refreshData': 'Oppdater ved start',
	'slideshowLabel': 'Lysbildefremvisning',
	'panAndZoomLabel': 'Guidet reise',
	'slideShowLayoutLabel': 'Lysbildefremvisningslayout',
	'panAndZoomLayoutLabel': 'Layout for guidet reise',
	'panAndZoomLayoutFooter': 'En layout for guidet reise er en samling med scener på ett enkelt lerret. Når du kjører denne typen historie, zoomer og panorerer presentasjonen på hver enkelt scene i rekkefølge. Dette er forskjellig fra en layout med lysbildefremvisning, der hver enkelt scene blir vist på et nytt lerret. Layouten for guidet reise med tre scener knyttet sammen av streker gjør det mulig for deg å opprette en vannrett sekvens med scener. Dette er nyttig for å vise en tidslinje.',
	'PanAndZoomLayout1': '5 scener ordnet i en rektangulær form',
	'PanAndZoomLayout2': '4 scener ordnet i en trappeform fra venstre mot høyre',
	'PanAndZoomLayout3': '6 scener ordnet i en rektangulær form',
	'PanAndZoomLayout4': '7 scener ordnet i en rektangulær form, med 6 små scener øverst og 1 stor scene nederst',
	'PanAndZoomLayout5': '3 scener ordnet med 2 små scener øverst og 1 stor scene nederst',
	'PanAndZoomLayout6': 'En sekvens med 4 scener ordnet vannrett',
	'pageSelectWarning': 'Velg en scene.',
	'noSceneTransitionLabel': 'Ingen',
	'sceneTransitionPropertyLabel': 'Sceneovergang',
	'animatedPathSceneTransitionLabel': 'Animert bane',
	'sweepSceneTransitionLabel': 'Sveip',
	'storyTypeLabel': 'Historitype',
	'layoutLabel': 'Layout',
	'tabName_animation': 'Animasjon',
	'propAniAnimation': 'Animasjon',
	'propAniTypeEntrance': 'Inngangsanimasjon',
	'propAniDirectionIn': 'Inngangsretning',
	'propAniTypeExit': 'Utgangsanimasjon',
	'propAniDirectionOut': 'Utgangsretning',
	'propAniDirection': 'Retning',
	'propAniEntrance': 'Inngang',
	'propAniTypeEntranceSlideIn': 'Skli inn',
	'propAniTypeEntranceFadeIn': 'Ton inn',
	'propAniTypeEntrancePivotIn': 'Pivoter inn',
	'propAniTypeEntranceScaleIn': 'Skaler inn',
	'propAniTypeEntranceShrinkIn': 'Krymp inn',
	'propAniDirectionInLeft': 'Fra venstre',
	'propAniDirectionInRight': 'Fra høyre',
	'propAniDirectionInTop': 'Fra topp',
	'propAniDirectionInBottom': 'Fra bunn',
	'propAniExit': 'Avslutt',
	'propAniTypeExitSlideIn': 'Skli ut',
	'propAniTypeExitFadeIn': 'Ton ut',
	'propAniTypeExitPivotOut': 'Pivoter ut',
	'propAniTypeExitScaleIn': 'Skaler ut',
	'propAniTypeExitExpandOut': 'Utvid ut',
	'propAniDirectionOutLeft': 'Til venstre',
	'propAniDirectionOutRight': 'Til høyre',
	'propAniDirectionOutTop': 'Til topp',
	'propAniDirectionOutBottom': 'Til bunn',
	'propAniEntranceTime': 'Start (sek):',
	'propAniExitTime': 'Slutt (sek):',
	'animationNoEntranceText': 'Inngangsanimasjonen vil ikke bli vist hvis widgeten er på begynnelsen av scenen.',
	'animationNoExitText': 'Utgangssanimasjonen vil ikke bli vist hvis widgeten er på slutten av scenen.',
	'propAniTypeDataEntrance': 'Datainngang',
	'propAniRevealDuration': 'Varighet på inngangsanimasjon',
	'timelineAnimationProperties': 'Åpne animasjonsegenskaper',
	'scenesPropertiesSection': 'Scener',
	'editStoryCoachMarkTitle': 'Rediger historie',
	'editStoryCoachMarkContents': 'Klikk på blyantikonet for å redigere denne historien.',
	'addDataStoryCoachMarkContents': 'Dra og slipp data fra datapanelet til historien.',
	'expandSceneCoachmarkTitle': 'Åpne tidslinje',
	'expandSceneCoachmarkContents': 'Animer en scene ved å justere objektsynligheten basert på tid og varighet.',
	'overviewCoachmarkTitle': 'Oversiktsscener',
	'overviewCoachmarkContents': 'Bruk oversiktsscenene på begynnelsen og slutten av historien for å vise det overordnede bildet for alle scenene. Fra en oversiktsscene klikker og drar du en scene for å bytte den med en annen scene. Du kan vise eller skjule oversiktsscenene i historieegenskapene.',
	'animatedPathCoachmarkTitle': 'Animert bane',
	'animatedPathCoachmarkContents': 'Hvis du vil animere et objekt fra en scene til en annen, dupliserer du en scene med et objekt. Deretter flytter du, endrer størrelse eller roterer du det dupliserte objektet i den nye scenen.',
	'propShowStoryOverviewFirstSlide': 'Vis alle scener på begynnelsen',
	'propShowStoryOverviewLastSlide': 'Vis alle scener på slutten',
	'storySceneSingleCountLabel': '1 scene',
	'storySceneCountLabel': '%{count} scener',
	'storySceneRangeCountLabel': 'Scene %{index} av %{count}',
	'storySceneExpand': 'Åpne tidslinje',
	'storySceneActionMenu': 'Start meny med scenealternativer',
	'timelineRightContainerLabel': 'Knappekontrollgruppe for tidslinje',
	'timelineViewLabel': 'Tidslinje',
	'timelineZoomFit': 'Zoom for å tilpasse',
	'timelineZoomIn': 'Zoom inn',
	'timelineZoomOut': 'Zoom ut',
	'timelinePositionIndicator': 'posisjonsindikator på tidslinje ved %{position}',
	'timelinePositionIndicatorMoveLeftTo': 'flytting av posisjonsindikator på tidslinje mot venstre til %{position}',
	'timelinePositionIndicatorMoveRightTo': 'flytting av posisjonsindikator på tidslinje mot høyre til %{position}',
	'sceneStart': 'Gå til begynnelsen av scenen ved %{position}',
	'sceneEnd': 'Gå til slutten av scenen ved %{position}',
	'timelineHighlightTitle': 'Utheving',
	'addTimelineHighlight': 'Legg til utheving',
	'addSceneBtnTitle': 'Legg til en ny scene med standardmal',
	'addSceneChevronBtnTitle': 'Velg en scenemal',
	'timelinePlay': 'Spill',
	'timelinePause': 'Pause',
	'sceneNavigation': 'Scenenavigering',
	'navNextScene': 'Neste scene',
	'navPrevScene': 'Forrige scene',
	'navPrevSceneAbbreviated': 'Forr scene',
	'navExitFullScreen': 'Avslutt full skjerm',
	'navToggleOverview': 'Slå oversikt av/på',
	'rowNumber': 'Rad %{number}',
	'overviewBtnLabel': 'Oversikt',
	'sceneListStart': 'Oversikt start',
	'sceneListEnd': 'Oversikt slutt',
	'timelineLeftHandle': 'venstre håndtak for %{name}',
	'timelineRightHandle': 'høyre håndtak for %{name}',
	'timelineLeftHandleNoTitle': 'venstre håndtak',
	'timelineRightHandleNoTitle': 'høyre håndtak',
	'timelineMoveLeft': 'Flytt %{object} mot venstre',
	'timelineMoveRight': 'Flytt %{object} mot høyre',
	'timelineMoveWidget': 'Tidslinjewidget flyttet til %{newStartTime} og %{newEndTime}',
	'timelineMoveWidgetStartTime': 'Starttidspunkt for tidslinjewidget endret til %{newStartTime}',
	'timelineMoveWidgetEndTime': 'Sluttidspunkt for tidslinjewidget endret til %{newEndTime}',
	'timelineMoveWidgetDown': 'Tidslinjewidget flyttet ned',
	'timelineMoveWidgetUp': 'Tidslinjewidget flyttet opp',
	'addSceneTitle': 'Legg til en scene',
	'blankSceneLayout': 'Blank',
	'titleSceneLayout': 'Tittel med undertittel',
	'sceneLayout1': 'Tittel med tekst ved siden av én visualisering',
	'sceneLayout2': 'Tittel med én visualisering',
	'sceneLayout3': 'Tittel med to visualiseringer',
	'sceneLayout4': 'Flerfunksjon',
	'sceneLayout5': 'Ingen tittel med tekst ved siden av én visualisering',
	'sceneLayout6': 'Flerfunksjon 2 ganger 2',
	'sceneLayout7': 'Flerfunksjon 2 ved siden av 1',
	'sceneLayout8': 'Flerfunksjon 1 ved siden av 2',
	'sceneLayout9': 'Flerfunksjon 1 over 2',
	'sceneLayout10': 'Flerfunksjon 2 over 1',
	'sceneLayout11': 'Flerfunksjon 4 over 1',
	'sceneLayout12': 'Flerfunksjon 1 over 1 ved siden av 2 ganger 2 over 1',
	'titleWidgetPlaceholderText': 'Skriv tittelen din her',
	'subtitleWidgetPlaceholderText': 'Skriv undertittelen din her',
	'createStoryViewTitle': 'Opprett historie',
	'defaultStoryName': 'Ny historie',
	'screenshot_label': 'Historien %{title}',
	'screenshot_label_scene': 'Scenen %{sceneTitle} i historien %{title}',
	'filmstripHandleOpenLabel': 'Åpne scenevelger',
	'filmstripHandleCloseLabel': 'Lukk scenevelger'
});
